import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PackagesWishListCard from "src/Components/WebsiteComponents/HomePage/Cards/PackagesWishListCard";
import PharmaWishListCard from "src/Components/WebsiteComponents/HomePage/Cards/PharmaWishListCard";
import TestWhishListCard from "src/Components/WebsiteComponents/HomePage/Cards/TestWhishListCard";
import httpRequest from "src/helpers/httpRequest";
import { IPaginated } from "src/types/paginated";
import qs from "qs";
import { Loader } from "lucide-react";
import NoItemUI from "src/Components/NoItemUI";
import { useNavigate } from "react-router-dom";
import NoItemImg from "src/assets/images/not-data/no-pharma.png";
import InfinteScrollWrapper from "src/Components/GlobalComponents/Widget/InfinteScrollWrapper";

const data = [
  {
    id: 1,
    description:
      "Garden of Life Dr. Formulated Women’s Probiotics, Supports Vaginal, Digestive & Immune Health 30.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz1wmn4xyHnFvtA5PyxXD3AR8dYo5ap4DZ3A&s",
    regularPrice: 1000,
    salePrice: 800,
  },
  {
    id: 2,
    description:
      "Garden of Life Dr. Formulated Women’s Probiotics, Supports Vaginal, Digestive & Immune Health 30.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz1wmn4xyHnFvtA5PyxXD3AR8dYo5ap4DZ3A&s",
    regularPrice: 1000,
    salePrice: 800,
  },
  {
    id: 3,
    description:
      "Garden of Life Dr. Formulated Women’s Probiotics, Supports Vaginal, Digestive & Immune Health 30.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz1wmn4xyHnFvtA5PyxXD3AR8dYo5ap4DZ3A&s",
    regularPrice: 1000,
    salePrice: 800,
  },
];

interface IObj {
  _id: string;
  productName: string;
  image: string;
  price: number;
  salePrice: number;
  brandsName: string;
  shortDescription: string;
  isLiked: boolean;
  prescriptionRequired: boolean;
  quantity: number;
}

interface IResponse {
  documents: IObj[];
  paginated: IPaginated;
}

const PharmaWhishList = ({ onClose }: { onClose: () => void }) => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [data, setData] = useState<IObj[]>([]);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });
  const [queryParams, setQueryParams] = useState<{
    page: number;
    limit: number;
    bool: boolean;
  }>({
    page: 1,
    limit: 10,
    bool: false,
  });

  const handleRemove = (obj: { productId: string }) => {
    if (data?.length > 1) {
      setData((prev) => prev?.filter((v) => v._id !== obj?.productId));
    } else {
      handleQueryParamsChange({
        page: queryParams?.page > 1 ? queryParams?.page - 1 : queryParams?.page,
      });
    }
  };
  const fetch = async (params: Partial<typeof queryParams>) => {
    setIsLoader(true);
    const { bool, ...actulaParams } = params;
    const { res, err } = await httpRequest<IResponse>({
      path: `/inventory-favproduct/fav-pharma-products?${qs.stringify(
        actulaParams
      )}`,
    });
    if (res) {
      setData((prev) => [...prev, ...res?.documents.map((item) => ({ ...item, isLiked: true }))]);
      setPaginated(res?.paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };
  const handleQueryParamsChange = (
    params: Partial<typeof queryParams>,
    reset = true
  ) => {
    let updatedParams = { ...queryParams, ...params };
    if (reset) {
      setPaginated({
        currentPage: 1,
        totalPages: 1,
      });
      updatedParams.page = 1;
      setData([]);
    }
    fetch(updatedParams);
    setQueryParams(updatedParams);
  };
  useEffect(() => {
    handleQueryParamsChange(queryParams);
  }, []);

  return (
    <>
      {/* {isLoader ? ( */}
        {/* <div className="flex justify-center items-center h-full gap-2 min-h-[130px]">
          <Loader className="animate-spin" />
          <p className="font-Poppins-Regular font-size-14px text-[#333333]">
            Loading Favorite Pharma Products...
          </p>
        </div> */}
      {/* ) : data.length === 0 ? (
      ) : data.length === 0 ? (
        <div className="w-full mt-5">
          <NoItemUI
            text="No Products Found"
            text2="Your pharma products wishlist is empty. Explore and save products for quick access."
            iconImagePath={NoItemImg}
            onButtonClick={() => {
              onClose();
              navigate("/");
            }}
            ButtonText="Discover Pharma Products"
          />
        </div>
      ) : (
        data.map((d, index) => (
          <PharmaWishListCard
            key={d._id}
            data={d}
            heart_id={`heart-${index}`}
            button_id={`button-${index}`}
            handleRemove={() => handleRemove({ productId: d._id })}
          />
        ))
        )} */}
      <InfinteScrollWrapper
        isLoading={isLoader}
        length={data?.length}
        currentPage={queryParams?.page}
        totalPages={paginated?.totalPages}
        onLoadMore={(page) => {
          handleQueryParamsChange({ page: page }, false);
        }}
        calculateHeight
        noDataOptions={{
          text: "No Products Found",
          text2: "Your pharma products wishlist is empty. Explore and save products for quick access.",
          iconImagePath: NoItemImg,
          buttonOnPress: () => {
            onClose();
            navigate("/category");
          },
          buttonText: "Discover Pharma Products",
        }}
        itemClassName=".tab-slider-container-main"
      >
        {data.map((d, index) => (
          <PharmaWishListCard
            key={d._id}
            data={d}
            heart_id={`heart-${index}`}
            button_id={`button-${index}`}
            handleRemove={() => handleRemove({ productId: d._id })}
          />
        ))}
      </InfinteScrollWrapper>
    </>
  );
};

export default PharmaWhishList;
